import { render, staticRenderFns } from "./Identification.vue?vue&type=template&id=0a64ddd1"
import script from "./Identification.vue?vue&type=script&lang=js"
export * from "./Identification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports